import {
  Companion_getInstance139dzwc3zihpx as Companion_getInstance,
  CompletionResponseSerializable2r3u7efewr7mg as CompletionResponseSerializable,
  CompletionResponseType348wa0e7ydpli as CompletionResponseType,
} from './serialization.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  AccessInfoj60d6hx1qs8r as AccessInfo,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { DisputeType169p3tc7g9isk as DisputeType } from './CompletionResponse.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareCompletionResponseSerializableFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [CompletionResponseSerializable_type_getInstance(), CompletionResponseSerializable_accessInfo_getInstance(), CompletionResponseSerializable_reasons_getInstance(), CompletionResponseSerializable_raiseIssue_getInstance(), CompletionResponseSerializable_fileDispute_getInstance(), CompletionResponseSerializable_displayName_getInstance(), CompletionResponseSerializable_credit_getInstance(), CompletionResponseSerializable_due_getInstance(), CompletionResponseSerializable_remedyComplete_getInstance(), CompletionResponseSerializable_proposal_getInstance(), CompletionResponseSerializable_time_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function CompletionResponseSerializable_type$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function CompletionResponseSerializable_type$_get_name_$ref_v6eayy() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_type$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_type$_get_serializer_$ref_m2h5b() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_type$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function CompletionResponseSerializable_type$_get_annotations_$ref_2wfp1x() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_typeClass;
function CompletionResponseSerializable_type() {
  if (CompletionResponseSerializable_typeClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_type_instance = this;
        var tmp = this;
        tmp.r8c_1 = lazy(CompletionResponseSerializable_type$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s8c_1 = lazy(CompletionResponseSerializable_type$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t8c_1 = lazy(CompletionResponseSerializable_type$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.r8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_type$_get_name_$ref_v6eayy(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.v8c_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      g8d(receiver, value) {
        return receiver.h8d(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.g8d(tmp, value instanceof CompletionResponseType() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_type$_get_serializer_$ref_m2h5b(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t8c_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_type$_get_annotations_$ref_2wfp1x(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_type', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_typeClass = $;
  }
  return CompletionResponseSerializable_typeClass;
}
var CompletionResponseSerializable_type_instance;
function CompletionResponseSerializable_type_getInstance() {
  if (CompletionResponseSerializable_type_instance === VOID)
    new (CompletionResponseSerializable_type())();
  return CompletionResponseSerializable_type_instance;
}
function CompletionResponseSerializable_accessInfo$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function CompletionResponseSerializable_accessInfo$_get_name_$ref_31fmwy() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_accessInfo$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_accessInfo$_get_serializer_$ref_t9q7iv() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_accessInfo$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function CompletionResponseSerializable_accessInfo$_get_annotations_$ref_w4layb() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_accessInfoClass;
function CompletionResponseSerializable_accessInfo() {
  if (CompletionResponseSerializable_accessInfoClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_accessInfo_instance = this;
        var tmp = this;
        tmp.i8d_1 = lazy(CompletionResponseSerializable_accessInfo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j8d_1 = lazy(CompletionResponseSerializable_accessInfo$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k8d_1 = lazy(CompletionResponseSerializable_accessInfo$annotations$delegate$lambda);
        this.l8d_1 = null;
        this.m8d_1 = 'null';
      }
      k20() {
        var tmp0 = this.i8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_accessInfo$_get_name_$ref_31fmwy(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.w8c_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      n8d(receiver, value) {
        return receiver.h8d(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.n8d(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_accessInfo$_get_serializer_$ref_t9q7iv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_accessInfo$_get_annotations_$ref_w4layb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_accessInfo', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_accessInfoClass = $;
  }
  return CompletionResponseSerializable_accessInfoClass;
}
var CompletionResponseSerializable_accessInfo_instance;
function CompletionResponseSerializable_accessInfo_getInstance() {
  if (CompletionResponseSerializable_accessInfo_instance === VOID)
    new (CompletionResponseSerializable_accessInfo())();
  return CompletionResponseSerializable_accessInfo_instance;
}
function CompletionResponseSerializable_reasons$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function CompletionResponseSerializable_reasons$_get_name_$ref_ji32vb() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_reasons$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_reasons$_get_serializer_$ref_jecw0w() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_reasons$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function CompletionResponseSerializable_reasons$_get_annotations_$ref_lt7uhw() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_reasonsClass;
function CompletionResponseSerializable_reasons() {
  if (CompletionResponseSerializable_reasonsClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_reasons_instance = this;
        var tmp = this;
        tmp.o8d_1 = lazy(CompletionResponseSerializable_reasons$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p8d_1 = lazy(CompletionResponseSerializable_reasons$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q8d_1 = lazy(CompletionResponseSerializable_reasons$annotations$delegate$lambda);
        this.r8d_1 = emptySet();
        this.s8d_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.o8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_reasons$_get_name_$ref_ji32vb(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.x8c_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      t8d(receiver, value) {
        return receiver.h8d(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.t8d(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_reasons$_get_serializer_$ref_jecw0w(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_reasons$_get_annotations_$ref_lt7uhw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_reasons', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_reasonsClass = $;
  }
  return CompletionResponseSerializable_reasonsClass;
}
var CompletionResponseSerializable_reasons_instance;
function CompletionResponseSerializable_reasons_getInstance() {
  if (CompletionResponseSerializable_reasons_instance === VOID)
    new (CompletionResponseSerializable_reasons())();
  return CompletionResponseSerializable_reasons_instance;
}
function CompletionResponseSerializable_raiseIssue$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function CompletionResponseSerializable_raiseIssue$_get_name_$ref_nmh0sd() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_raiseIssue$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_raiseIssue$_get_serializer_$ref_dzyvrw() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_raiseIssue$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function CompletionResponseSerializable_raiseIssue$_get_annotations_$ref_8bc1co() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_raiseIssueClass;
function CompletionResponseSerializable_raiseIssue() {
  if (CompletionResponseSerializable_raiseIssueClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_raiseIssue_instance = this;
        var tmp = this;
        tmp.u8d_1 = lazy(CompletionResponseSerializable_raiseIssue$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v8d_1 = lazy(CompletionResponseSerializable_raiseIssue$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w8d_1 = lazy(CompletionResponseSerializable_raiseIssue$annotations$delegate$lambda);
        this.x8d_1 = false;
        this.y8d_1 = 'false';
      }
      k20() {
        var tmp0 = this.u8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_raiseIssue$_get_name_$ref_nmh0sd(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.y8c_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      z8d(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.z8d(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.v8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_raiseIssue$_get_serializer_$ref_dzyvrw(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w8d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_raiseIssue$_get_annotations_$ref_8bc1co(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_raiseIssue', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_raiseIssueClass = $;
  }
  return CompletionResponseSerializable_raiseIssueClass;
}
var CompletionResponseSerializable_raiseIssue_instance;
function CompletionResponseSerializable_raiseIssue_getInstance() {
  if (CompletionResponseSerializable_raiseIssue_instance === VOID)
    new (CompletionResponseSerializable_raiseIssue())();
  return CompletionResponseSerializable_raiseIssue_instance;
}
function CompletionResponseSerializable_fileDispute$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function CompletionResponseSerializable_fileDispute$_get_name_$ref_ouw88e() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_fileDispute$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_fileDispute$_get_serializer_$ref_g4e41l() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_fileDispute$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function CompletionResponseSerializable_fileDispute$_get_annotations_$ref_io261v() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_fileDisputeClass;
function CompletionResponseSerializable_fileDispute() {
  if (CompletionResponseSerializable_fileDisputeClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_fileDispute_instance = this;
        var tmp = this;
        tmp.a8e_1 = lazy(CompletionResponseSerializable_fileDispute$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b8e_1 = lazy(CompletionResponseSerializable_fileDispute$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c8e_1 = lazy(CompletionResponseSerializable_fileDispute$annotations$delegate$lambda);
        this.d8e_1 = null;
        this.e8e_1 = 'null';
      }
      k20() {
        var tmp0 = this.a8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_fileDispute$_get_name_$ref_ouw88e(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.z8c_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      f8e(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.f8e(tmp, (value == null ? true : value instanceof DisputeType()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.b8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_fileDispute$_get_serializer_$ref_g4e41l(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_fileDispute$_get_annotations_$ref_io261v(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_fileDispute', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_fileDisputeClass = $;
  }
  return CompletionResponseSerializable_fileDisputeClass;
}
var CompletionResponseSerializable_fileDispute_instance;
function CompletionResponseSerializable_fileDispute_getInstance() {
  if (CompletionResponseSerializable_fileDispute_instance === VOID)
    new (CompletionResponseSerializable_fileDispute())();
  return CompletionResponseSerializable_fileDispute_instance;
}
function CompletionResponseSerializable_displayName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function CompletionResponseSerializable_displayName$_get_name_$ref_t1s1x3() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_displayName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_displayName$_get_serializer_$ref_7rowo2() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_displayName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function CompletionResponseSerializable_displayName$_get_annotations_$ref_bnew9u() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_displayNameClass;
function CompletionResponseSerializable_displayName() {
  if (CompletionResponseSerializable_displayNameClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_displayName_instance = this;
        var tmp = this;
        tmp.g8e_1 = lazy(CompletionResponseSerializable_displayName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h8e_1 = lazy(CompletionResponseSerializable_displayName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i8e_1 = lazy(CompletionResponseSerializable_displayName$annotations$delegate$lambda);
        this.j8e_1 = null;
        this.k8e_1 = 'null';
      }
      k20() {
        var tmp0 = this.g8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_displayName$_get_name_$ref_t1s1x3(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.a8d_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      l8e(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.l8e(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.h8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_displayName$_get_serializer_$ref_7rowo2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_displayName$_get_annotations_$ref_bnew9u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_displayName', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_displayNameClass = $;
  }
  return CompletionResponseSerializable_displayNameClass;
}
var CompletionResponseSerializable_displayName_instance;
function CompletionResponseSerializable_displayName_getInstance() {
  if (CompletionResponseSerializable_displayName_instance === VOID)
    new (CompletionResponseSerializable_displayName())();
  return CompletionResponseSerializable_displayName_instance;
}
function CompletionResponseSerializable_credit$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function CompletionResponseSerializable_credit$_get_name_$ref_ns25uf() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_credit$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_credit$_get_serializer_$ref_1aaw8g() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_credit$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function CompletionResponseSerializable_credit$_get_annotations_$ref_nroor8() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_creditClass;
function CompletionResponseSerializable_credit() {
  if (CompletionResponseSerializable_creditClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_credit_instance = this;
        var tmp = this;
        tmp.m8e_1 = lazy(CompletionResponseSerializable_credit$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n8e_1 = lazy(CompletionResponseSerializable_credit$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o8e_1 = lazy(CompletionResponseSerializable_credit$annotations$delegate$lambda);
        this.p8e_1 = null;
        this.q8e_1 = 'null';
      }
      k20() {
        var tmp0 = this.m8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_credit$_get_name_$ref_ns25uf(), null);
        return tmp0.f2();
      }
      r8e(receiver) {
        return receiver.b8d_1;
      }
      m2j(receiver) {
        var tmp = this.r8e(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
        return tmp == null ? null : new (MonetaryValue())(tmp);
      }
      s8e(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof MonetaryValue()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.a5s_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.s8e(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.n8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_credit$_get_serializer_$ref_1aaw8g(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_credit$_get_annotations_$ref_nroor8(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_credit', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_creditClass = $;
  }
  return CompletionResponseSerializable_creditClass;
}
var CompletionResponseSerializable_credit_instance;
function CompletionResponseSerializable_credit_getInstance() {
  if (CompletionResponseSerializable_credit_instance === VOID)
    new (CompletionResponseSerializable_credit())();
  return CompletionResponseSerializable_credit_instance;
}
function CompletionResponseSerializable_due$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function CompletionResponseSerializable_due$_get_name_$ref_kmfti6() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_due$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_due$_get_serializer_$ref_i3bvp7() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_due$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function CompletionResponseSerializable_due$_get_annotations_$ref_nhd7mf() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_dueClass;
function CompletionResponseSerializable_due() {
  if (CompletionResponseSerializable_dueClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_due_instance = this;
        var tmp = this;
        tmp.t8e_1 = lazy(CompletionResponseSerializable_due$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u8e_1 = lazy(CompletionResponseSerializable_due$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v8e_1 = lazy(CompletionResponseSerializable_due$annotations$delegate$lambda);
        this.w8e_1 = null;
        this.x8e_1 = 'null';
      }
      k20() {
        var tmp0 = this.t8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_due$_get_name_$ref_kmfti6(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.c8d_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      y8e(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.y8e(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_due$_get_serializer_$ref_i3bvp7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_due$_get_annotations_$ref_nhd7mf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_due', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_dueClass = $;
  }
  return CompletionResponseSerializable_dueClass;
}
var CompletionResponseSerializable_due_instance;
function CompletionResponseSerializable_due_getInstance() {
  if (CompletionResponseSerializable_due_instance === VOID)
    new (CompletionResponseSerializable_due())();
  return CompletionResponseSerializable_due_instance;
}
function CompletionResponseSerializable_remedyComplete$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function CompletionResponseSerializable_remedyComplete$_get_name_$ref_mln7br() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_remedyComplete$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_remedyComplete$_get_serializer_$ref_drnpn4() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_remedyComplete$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function CompletionResponseSerializable_remedyComplete$_get_annotations_$ref_gqftkc() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_remedyCompleteClass;
function CompletionResponseSerializable_remedyComplete() {
  if (CompletionResponseSerializable_remedyCompleteClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_remedyComplete_instance = this;
        var tmp = this;
        tmp.z8e_1 = lazy(CompletionResponseSerializable_remedyComplete$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a8f_1 = lazy(CompletionResponseSerializable_remedyComplete$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b8f_1 = lazy(CompletionResponseSerializable_remedyComplete$annotations$delegate$lambda);
        this.c8f_1 = null;
        this.d8f_1 = 'null';
      }
      k20() {
        var tmp0 = this.z8e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_remedyComplete$_get_name_$ref_mln7br(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.d8d_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      e8f(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.e8f(tmp, (value == null ? true : value instanceof CompletionResponseSerializable()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.a8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_remedyComplete$_get_serializer_$ref_drnpn4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_remedyComplete$_get_annotations_$ref_gqftkc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_remedyComplete', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_remedyCompleteClass = $;
  }
  return CompletionResponseSerializable_remedyCompleteClass;
}
var CompletionResponseSerializable_remedyComplete_instance;
function CompletionResponseSerializable_remedyComplete_getInstance() {
  if (CompletionResponseSerializable_remedyComplete_instance === VOID)
    new (CompletionResponseSerializable_remedyComplete())();
  return CompletionResponseSerializable_remedyComplete_instance;
}
function CompletionResponseSerializable_proposal$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function CompletionResponseSerializable_proposal$_get_name_$ref_h9uv26() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_proposal$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_proposal$_get_serializer_$ref_o1h8fd() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_proposal$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function CompletionResponseSerializable_proposal$_get_annotations_$ref_jyp9zh() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_proposalClass;
function CompletionResponseSerializable_proposal() {
  if (CompletionResponseSerializable_proposalClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_proposal_instance = this;
        var tmp = this;
        tmp.f8f_1 = lazy(CompletionResponseSerializable_proposal$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g8f_1 = lazy(CompletionResponseSerializable_proposal$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h8f_1 = lazy(CompletionResponseSerializable_proposal$annotations$delegate$lambda);
        this.i8f_1 = null;
        this.j8f_1 = 'null';
      }
      k20() {
        var tmp0 = this.f8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_proposal$_get_name_$ref_h9uv26(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.e8d_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      e8f(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.e8f(tmp, (value == null ? true : value instanceof CompletionResponseSerializable()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_proposal$_get_serializer_$ref_o1h8fd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_proposal$_get_annotations_$ref_jyp9zh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_proposal', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_proposalClass = $;
  }
  return CompletionResponseSerializable_proposalClass;
}
var CompletionResponseSerializable_proposal_instance;
function CompletionResponseSerializable_proposal_getInstance() {
  if (CompletionResponseSerializable_proposal_instance === VOID)
    new (CompletionResponseSerializable_proposal())();
  return CompletionResponseSerializable_proposal_instance;
}
function CompletionResponseSerializable_time$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function CompletionResponseSerializable_time$_get_name_$ref_ngaqyr() {
  return (p0) => p0.k20();
}
function CompletionResponseSerializable_time$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CompletionResponseSerializable_time$_get_serializer_$ref_rm6nq4() {
  return (p0) => p0.j2j();
}
function CompletionResponseSerializable_time$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function CompletionResponseSerializable_time$_get_annotations_$ref_cdbaqg() {
  return (p0) => p0.bz();
}
var CompletionResponseSerializable_timeClass;
function CompletionResponseSerializable_time() {
  if (CompletionResponseSerializable_timeClass === VOID) {
    class $ {
      constructor() {
        CompletionResponseSerializable_time_instance = this;
        var tmp = this;
        tmp.k8f_1 = lazy(CompletionResponseSerializable_time$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l8f_1 = lazy(CompletionResponseSerializable_time$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m8f_1 = lazy(CompletionResponseSerializable_time$annotations$delegate$lambda);
        this.n8f_1 = null;
        this.o8f_1 = 'null';
      }
      k20() {
        var tmp0 = this.k8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CompletionResponseSerializable_time$_get_name_$ref_ngaqyr(), null);
        return tmp0.f2();
      }
      u8c(receiver) {
        return receiver.f8d_1;
      }
      m2j(receiver) {
        return this.u8c(receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE());
      }
      y8e(receiver, value) {
        return receiver.h8d(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CompletionResponseSerializable() ? receiver : THROW_CCE();
        return this.y8e(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.l8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CompletionResponseSerializable_time$_get_serializer_$ref_rm6nq4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m8f_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CompletionResponseSerializable_time$_get_annotations_$ref_cdbaqg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CompletionResponseSerializable_time', VOID, VOID, [SerializableProperty()]);
    CompletionResponseSerializable_timeClass = $;
  }
  return CompletionResponseSerializable_timeClass;
}
var CompletionResponseSerializable_time_instance;
function CompletionResponseSerializable_time_getInstance() {
  if (CompletionResponseSerializable_time_instance === VOID)
    new (CompletionResponseSerializable_time())();
  return CompletionResponseSerializable_time_instance;
}
//region block: exports
export {
  prepareCompletionResponseSerializableFields as prepareCompletionResponseSerializableFieldszx964npiada,
};
//endregion

//# sourceMappingURL=CompletionResponseSerializableFields.mjs.map
